import client from '@/api/PortalBackendService/_portalBackendServiceClient'
import moment from 'moment'
import {Settings as LuxonSettings} from 'luxon'

/**
 * Returns a maximum of {limit} TripLineItems from a specific date on for a specific transitaccount
 *
 * @param {int} cardId Card ID
 * @param {object} dateTimeFrom Date from which items are requested, MomentJs object
 * @param {object} [dateTimeTo=null] The datetime to, the items have to be returned, MomentJs object. Default now.
 * @param {object} [params={}] Object of additional request parameters:
 * @param {number} [params.limit] Number of items to be returned. 10 by default
 * @param {number} [params.offset] The offset from where the results have to be returned. 0 by default
 * @param {string} [params.organisationName] Name of the PTO ('NS', 'ARRIVA', etc.)
 * @param {string} [params.transportType] '1': Bus, '2': Train, '3': Metro/Underground, '4': Tram, '5': Taxi, '6': Waterborne vehicle, '11': Backoffice/other
 * @param {string} [params.routeNumber] e.g. Bus number, filled if a linenumber is available
 * @param {string} [params.paymentMethod] 1: Visa, 2: EMV, 3: IDEAL, 4: PayPal, 5: ApplePay, 11: Backoffice/other
 * @param {string} [params.tokenId] (Internal)Id of the token used for the trip
 * @param {string} [params.srfid] Service reference ID
 *
 * @returns {Promise<object>} Promise object representing the array of data
 */
function getTrips(cardId, dateTimeFrom, dateTimeTo, params) {
  return new Promise(((resolve, reject) => {
    if (!moment.isMoment(dateTimeFrom)) {
      throw new Error('dateTimeFrom should be a MomentJs object')
    }
    if (!moment.isMoment(dateTimeTo)) {
      dateTimeTo = moment()
    }

    if (typeof params !== 'object') {
      params = {}
    }

    params['dateTimeFrom'] = dateTimeFrom.utc().format()
    params['dateTimeUntil'] = dateTimeTo.utc().format()

    client.get(`/user/card/${cardId}/trips`, {
      params: params
    })
      .then(({data}) => {
        resolve(data)
      })
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  }))
}

/**
 * Returns a maximum of {limit} TripLineItems from a specific date on for a specific transitaccount
 *
 * @param {int} cardId Card ID
 * @param {string} srfId Service reference ID
 * @param {object} [params={}] Object of additional request parameters:
 * @param {number} [params.limit] Number of items to be returned. 10 by default
 * @param {number} [params.offset] The offset from where the results have to be returned. 0 by default
 * @param {string} [params.organisationName] Name of the PTO ('NS', 'ARRIVA', etc.)
 * @param {string} [params.transportType] '1': Bus, '2': Train, '3': Metro/Underground, '4': Tram, '5': Taxi, '6': Waterborne vehicle, '11': Backoffice/other
 * @param {string} [params.routeNumber] e.g. Bus number, filled if a linenumber is available
 * @param {string} [params.paymentMethod] 1: Visa, 2: EMV, 3: IDEAL, 4: PayPal, 5: ApplePay, 11: Backoffice/other
 * @param {string} [params.tokenId] (Internal)Id of the token used for the trip
 *
 * @returns {Promise<object>} Promise object representing the array of data
 */
function getTripsWithSrfid(cardId, srfId, params) {
  return new Promise(((resolve, reject) => {
    if (typeof params !== 'object') {
      params = {}
    }

    params['srfid'] = srfId
    params['language'] = LuxonSettings.defaultLocale

    client.get(`/user/card/${cardId}/trips`, {
      params: params
    })
      .then(({data}) => {
        resolve(data)
      })
      .catch(error => {
        if (error.response) {
          reject(error.response)
        }
        reject(error)
      })
  }))
}

function getPAYGPaymentAndTripDetails(cardId, srfId, params) {
  return new Promise(((resolve, reject) => {
    if (typeof params !== 'object') {
      params = {}
    }

    params['srfid'] = srfId
    params['language'] = LuxonSettings.defaultLocale

    client.get(`/transit-accounts/${cardId}/payment-payg`, {
      params: params
    })
      .then(({data}) => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  }))
}

export default {
  getTrips,
  getTripsWithSrfid,
  getPAYGPaymentAndTripDetails
}
